import ToolTip, { tooltipProps } from './Tooltip';
import TooltipEllipsis from './PfTooltipEllipsis';
export { tooltipProps, TooltipEllipsis };
ToolTip.TooltipEllipsis = TooltipEllipsis;
export default Object.assign(ToolTip, {
    install: (app) => {
        app.component(ToolTip.name, ToolTip);
        app.component(TooltipEllipsis.name, TooltipEllipsis);
        return app;
    },
});
